export const environment = {
    production: true,
    backendHost: 'https://phonee.onenergy.mvm.hu',
    backendURL: 'https://phonee.onenergy.mvm.hu/phonee/rest',
    // Dev környezetbe szánt disztribúció esetén a PhoneeRest.BASE_REMOTING_PORT értékét is állítani kell!
};
